import { lazy, Suspense, type ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { HomePage } from './pages/HomePage';

const MaterialsPage = lazy(() => import('./pages/MaterialsPage').then((module) => ({ default: module.MaterialsPage })));
const GeneratePage = lazy(() => import('./pages/GeneratePage').then((module) => ({ default: module.GeneratePage })));
const CoursesPage = lazy(() => import('./pages/CoursesPage').then((module) => ({ default: module.CoursesPage })));
const CourseDetailPage = lazy(() => import('./pages/CourseDetailPage').then((module) => ({ default: module.CourseDetailPage })));
const ProfilePage = lazy(() => import('./pages/ProfilePage').then((module) => ({ default: module.ProfilePage })));
const MediaLibraryPage = lazy(() => import('./pages/MediaLibraryPage').then((module) => ({ default: module.MediaLibraryPage })));
const LoginPage = lazy(() => import('./pages/LoginPage').then((module) => ({ default: module.LoginPage })));
const GenerationHistoryPage = lazy(() => import('./pages/GenerationHistoryPage').then((module) => ({ default: module.GenerationHistoryPage })));
const GenerationJobPage = lazy(() => import('./pages/GenerationJobPage').then((module) => ({ default: module.GenerationJobPage })));
const LegalPage = lazy(() => import('./pages/LegalPage').then((module) => ({ default: module.LegalPage })));

function lazyRoute(content: ReactNode) {
  return <Suspense fallback={<div className="route-loading" role="status">正在加载…</div>}>{content}</Suspense>;
}

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/materials" element={lazyRoute(<MaterialsPage />)} />
        <Route path="/generate/:mode" element={lazyRoute(<GeneratePage />)} />
        <Route path="/courses" element={lazyRoute(<CoursesPage />)} />
        <Route path="/courses/:id" element={lazyRoute(<CourseDetailPage />)} />
        <Route path="/me" element={lazyRoute(<ProfilePage />)} />
        <Route path="/my-assets" element={lazyRoute(<MediaLibraryPage />)} />
        <Route path="/login" element={lazyRoute(<LoginPage />)} />
        <Route path="/generation-history" element={lazyRoute(<GenerationHistoryPage />)} />
        <Route path="/generation-history/:id" element={lazyRoute(<GenerationJobPage />)} />
        <Route path="/terms" element={lazyRoute(<LegalPage kind="terms" />)} />
        <Route path="/privacy" element={lazyRoute(<LegalPage kind="privacy" />)} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
